"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Editor_1 = require("./Editor");
exports.Editor = Editor_1.Editor;
//# sourceMappingURL=index.js.map